import React from 'react'
import Shimmer from './Shimmer'

import './Skeleton.css'
const Skeleton = ({theme, children}) => {
    const themeClass = theme || 'light'

    return (
        <div className={`skeleton-wrapper ${themeClass}`}>
            <div className={'center'}>
                <div >
                    {children}
                </div>
            </div>
            <Shimmer/>
        </div>
    )
}

export default Skeleton;

// <div style={{width: '400px'}}>
//     <Skeleton>
//         <Row>
//             <Col lg={6}>
//                 <SkeletonElement type='avatar'/>
//             </Col>
//             <Col lg={12}>
//                 <SkeletonElement type='title'/>
//                 <SkeletonElement type='title'/>
//                 <SkeletonElement type='title'/>
//                 <SkeletonElement type='title'/>
//             </Col>
//             <Col xs={12}>
//                 <SkeletonElement type='text'/>
//                 <SkeletonElement type='text'/>
//                 <SkeletonElement type='text'/>
//                 <SkeletonElement type='text'/>
//             </Col>
//         </Row>
//     </Skeleton>
// </div>
